import { Outlet, useOutletContext } from 'react-router'
import Global1PaneFooter from './Global1PaneFooter'
import { Suspense, useEffect, useState } from 'react'
import GlobalLeftbar from './GlobalLeftbar'
import { Box, useTheme } from '@mui/material'
import { isMobile, isTablet } from '../../utils/functions'
import { PCClientDialogProvider } from '../../contexts/PCClientDialogContext'

// css media query を利用していないのはどっちみち処理の分岐が必要だから
// 及びパフォーマンスの観点から

const is_mobile = isMobile()
const is_tablet = isTablet()

const mkPane = (wide: 'full' | 'middle' | 'timeline') => {
  const is_tablet_tate = is_tablet && window.innerWidth < window.innerHeight
  const is_2 = window.innerWidth < 1280 || wide === 'full' || is_tablet_tate
  const num = is_mobile ? 1 :
              is_2      ? 2 :
                          3 as const
  const is_wide_short = window.innerWidth < 800 || is_tablet_tate
  const side_size = num === 1 ? 0
                              : is_wide_short ? 96 : 280 as const
  return {num, side_size} as const
}

type Props = {
  // 'timeline': 3ペインでも中央カラムを全幅にする（タイムラインの全幅スクロール用。
  //            中身の中央寄せは各ページ側が担当）
  wide: 'full' | 'middle' | 'timeline'
  is_footer?: boolean
}
const GlobalLayout: React.FC<Props> = ({wide, is_footer}) => {
  const [pane, setPane] = useState<{num: 1 | 2 | 3, side_size: 0 | 96 | 280}>(mkPane(wide))
  const theme = useTheme()
  // @ts-expect-error テーマの型が不明 | やや邪悪だがミスがあれば一発でわかるためこのまま
  const header_height: string = theme.components.MuiToolbar.styleOverrides.root.height

  useEffect(() => {
    const listener = () => {
      const new_pane = mkPane(wide)
      if (new_pane.num !== pane.num || new_pane.side_size !== pane.side_size) {
        setPane(new_pane)
      }
    }
    window.addEventListener('resize', listener)
    return () => { window.removeEventListener('resize', listener) }
  }, [pane.num, pane.side_size, wide])

  useEffect(() => {
    setPane(mkPane(wide))
  }, [wide])

  return <PCClientDialogProvider>
    <Box
      sx={{
        display: pane.num === 2 ? 'flex' : 'block',
        flexDirection: 'row',
        // テーマのヘッダー分の高さ + safe area
        paddingTop: header_height,
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)',
        height: '100dvh',
        width: '100%',
        overflow: 'hidden',
        boxSizing: 'border-box'
      }}
    >
      {pane.num !== 1 && <GlobalLeftbar pane={pane.num} side_size={pane.side_size}/>}

      <Box
        sx={{
          flex: pane.num === 3 ? undefined : 1,
          // timeline は3ペインでも全幅（中身は各ページが中央寄せ）。それ以外は640中央寄せ
          width: pane.num === 3 ? (wide === 'timeline' ? '100%' : '640px') : undefined,
          minWidth: 0, // flexで横幅がtextで伸長しないために必要
          margin: `0 ${pane.num === 3 && wide !== 'timeline' ? 'auto' : '0'}`,
          height: '100%',
          display: 'flex', flexDirection: 'column',
          position: 'relative', bottom: 0,
          //overflow: 'auto',
        }}
      >
        <div style={{
          display: 'flex', flexGrow: 1,  overflow: 'hidden',
        }}>
          <Suspense>
            <Outlet context={pane.side_size}/>
          </Suspense>
        </div>
        {pane.num === 1 && is_footer && <Global1PaneFooter/>}
      </Box>
    </Box>
  </PCClientDialogProvider>
}
export default GlobalLayout

export const useLayoutSideSize = ()=> useOutletContext<number>()

export const WIDE_SIDE_SIZE = 280 as const
